module.exports = __webpack_public_path__ + "img/angular-js.94abb990.png";